<template>
  <a-modal
    title="事件详情"
    :visible="showTubeView"
    :width="800"
    destroyOnClose
    @ok="closeTubeView"
    @cancel="closeTubeView"
  >
    <a-row class="form-row" type="flex" justify="center" :gutter="4">
      <a-col :md="12" :sm="24">
        <a-form-model-item label="事件名称">{{record.eventName}}</a-form-model-item>
      </a-col>
      <a-col :md="12" :sm="24">
        <a-form-model-item label="事件类型">{{record.eventTypes}}</a-form-model-item>
      </a-col>
      <a-col :md="24" :sm="24">
        <a-form-model-item label="位置" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }"></a-form-model-item>
      </a-col>
      <a-col :md="24" :sm="24">
        <a-form-model-item
          label="地址"
          :label-col="{ span: 3 }"
          :wrapper-col="{ span: 20 }"
        >{{record.address}}</a-form-model-item>
      </a-col>
      <a-col :md="12" :sm="24">
        <a-form-model-item label="上报人">{{record.reportPerson}}</a-form-model-item>
      </a-col>
      <a-col :md="12" :sm="24">
        <a-form-model-item label="联系电话">{{record.phone}}</a-form-model-item>
      </a-col>
      <a-col :md="24" :sm="24">
        <a-form-model-item
          label="上报时间"
          :label-col="{ span: 3 }"
          :wrapper-col="{ span: 20 }"
        >{{record.reportTime}}</a-form-model-item>
      </a-col>
      <a-col :md="24" :sm="24">
        <a-form-model-item
          label="事件描述"
          :label-col="{ span: 3 }"
          :wrapper-col="{ span: 20 }"
        >{{record.eventDescription}}</a-form-model-item>
      </a-col>
    </a-row>
  </a-modal>
</template>
<script>
import moment from 'moment'
import addModal from './AddModal'
export default {
  components: {
    addModal
  },
  props: {},
  data() {
    return {
      queryUrl: '/pipe-network/user_water_meters/page/geophysical-point-numbers',
      showTubeView: false,
      id: '',
      addOrUpdateForm: {
        processMode: ''
      },
      record: {},
      zoneTreeData: [], // 分区数据选项
      eventTypeList: [],
      userlist: [],
      assistPersonsList: []
    }
  },
  computed: {
    rules() {
      return {}
    }
  },
  created() {},
  methods: {
    moment,
    edit(record) {
      this.showTubeView = true
      this.record = record
    },
    closeTubeView() {
      this.showTubeView = false
    }
  }
}
</script>

<style lang="less" scoped>
</style>
